export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'mso-monitoring',
      },
    },
    {
      name: 'coolers',
      displayName: 'menu.coolers',
      meta: {
        icon: 'mso-home_repair_service',
      },
    },
    {
      name: 'oils',
      displayName: 'menu.oils',
      meta: {
        icon: 'mso-home_repair_service',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'mso-supervisor_account',
      },
    },
    {
      name: 'system',
      displayName: 'menu.system.title',
      meta: {
        icon: 'mso-settings',
      },
      children: [
        {
          name: 'system-calculate-config',
          displayName: 'menu.system.calculate',
          meta: {
            icon: 'mso-calculate',
          },
        },
        {
          name: 'system-admin-config',
          displayName: 'menu.system.admin',
          meta: {
            icon: 'mso-groups',
          },
        },
        {
          name: 'system-user-account-config',
          displayName: 'menu.system.userAccount',
          meta: {
            icon: 'mso-groups',
          },
        },
        {
          name: 'system-email-config',
          displayName: 'menu.system.email',
          meta: {
            icon: 'mso-mail',
          },
        },
        {
          name: 'system-activate-email-config',
          displayName: 'menu.system.activateEmail',
          meta: {
            icon: 'mso-mail',
          },
        },
        {
          name: 'system-password-reset-email-config',
          displayName: 'menu.system.passwordResetEmail',
          meta: {
            icon: 'mso-mail',
          },
        },
        {
          name: 'system-icp-config',
          displayName: 'menu.system.icp',
          meta: {
            icon: 'mso-manufacturing',
          },
        },
      ],
    },
    {
      name: 'logs',
      displayName: 'menu.logs.title',
      meta: {
        icon: 'mso-event_note',
      },
      children: [
        {
          name: 'user-operation-logs',
          displayName: 'menu.logs.userOperation',
          meta: {
            icon: 'mso-event_note',
          },
        },
        {
          name: 'user-login-logs',
          displayName: 'menu.logs.userLogin',
          meta: {
            icon: 'mso-event_note',
          },
        },
      ],
    },
  ] as INavigationRoute[],
}
